import { checkGate, getExperiment, getLayer } from '@eventbrite/statsig';
import {
    ConfirmationPageReferralExperimentVariant,
    ExpressPaymentMethods,
    FOLLOW_CARD_PLACEMENT_EXPERIMENT,
    GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
    ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT,
    PostCheckoutMandatoryCustomQuestionsVariant,
    POST_CHECKOUT_MANDATORY_CUSTOM_QUESTIONS,
} from '../constants/statsig';

export const checkEnablePayPalLineItemsFeatureGate = () =>
    checkGate('checkout_enable_paypal_line_items');

export const getFollowCardPlacementExperiment = () =>
    getLayer(
        FOLLOW_CARD_PLACEMENT_EXPERIMENT.layer,
        FOLLOW_CARD_PLACEMENT_EXPERIMENT.param,
        FOLLOW_CARD_PLACEMENT_EXPERIMENT.defaultValue,
    );

export const getGooglePayOnTicketSelectionExperimentValue =
    (): ExpressPaymentMethods =>
        getLayer(
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
        );

export const getPostCheckoutMandatoryCustomQuestions =
    (): PostCheckoutMandatoryCustomQuestionsVariant =>
        getLayer(
            POST_CHECKOUT_MANDATORY_CUSTOM_QUESTIONS.layer,
            POST_CHECKOUT_MANDATORY_CUSTOM_QUESTIONS.param,
            POST_CHECKOUT_MANDATORY_CUSTOM_QUESTIONS.defaultValue,
        );

export const getReferralInOrderConfirmationExperiment =
    (): ConfirmationPageReferralExperimentVariant =>
        getExperiment(
            ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT.experiment,
            ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT.param,
            ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT.defaultValue,
        );
